import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { ConfigService } from "./config.service";
import { HeaderFactoryService } from "./header-factory.service";
import { LoginResult, EncriptionService } from 'digital-core';
import { UserProfile } from "../models/security";
import { UserProfileValidation } from "../models/profile/user-profile-validation";

@Injectable()
export class ProfileService {
  webApiUrl: string;
  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/json"
    })
  };

  constructor(private configService: ConfigService,
    private httpsClient: HttpClient,
    private encriptionService: EncriptionService,
    private headerFactoryService: HeaderFactoryService) {
  }

  getProfile(profile: UserProfile): Observable<UserProfileValidation> {
    if (profile) {
      return this.httpsClient.post<UserProfileValidation>(
        `${this.configService.apiUrl}api/v${this.configService.apiVersion
        }/profile/GetAulProfile`,
        profile,
        this.headerFactoryService.getAuthorizationHeaderOptions(["clientCMS", "parentCMS", "culture"])
      );
    } else {
      return of(new UserProfileValidation());
    }
  }

  getUserProfileFromAUL(profile: UserProfile, searchProfileByToken = true): Observable<string> {
    if (searchProfileByToken) {
      return this.httpsClient.get<any>(
        `${this.configService.aulApiUrl}api/v${this.configService.apiVersion
        }/UserProfile/user/me`,
        this.headerFactoryService.getAuthorizationHeaderOptions()
      );
    }

    return this.httpsClient.get<any>(
      `${this.configService.aulApiUrl}api/v${this.configService.apiVersion
      }/UserProfile/user/OktaLogin/${profile.UserName}`,
      this.headerFactoryService.getAuthorizationHeaderOptions()
    );

  }
  setUserProfile(profile: UserProfile) {
    // retrieve login info from local storage
    let loginResult: LoginResult = JSON.parse(
      this.encriptionService.dec(localStorage.getItem("login_info"))
    ) as LoginResult;

    //  map additional fields
    loginResult.CountryCode = profile.CountryCode;
    loginResult.Program = profile.Program;
    loginResult.StateCode = profile.StateCode;
    loginResult.StateDescription = profile.StateDescription;
    loginResult.AgentNumber = profile.AgentNumber;
    loginResult.StateLicenseNumber = profile.StateLicenseNumber;
    loginResult.FirstName = profile.FirstName.trim();
    loginResult.LastName = profile.LastName.trim();
    loginResult.FullName = profile.FirstName + " " + profile.LastName;
    loginResult.TelephoneNumber = profile.ContactPhone1 ? profile.ContactPhone1 : profile.ContactPhone2
    loginResult.SystemRole = profile.SystemRole;  
    loginResult.BranchId =  profile.BranchId;
    loginResult.Id = profile.Id;
    loginResult.IsAU = profile.IsAU;
    loginResult.DefaultRole = profile.DefaultRole;
    localStorage.removeItem("login_info");
    // save login info back to local storage
    localStorage.removeItem("login_info");
    localStorage.setItem(
      "login_info",
      this.encriptionService.enc(JSON.stringify(loginResult))
    );
    if (profile.DealershipDetails != null) {
      localStorage.removeItem("dealerShip_info");
      localStorage.setItem(
        "dealerShip_info",
        this.encriptionService.enc(JSON.stringify(profile.DealershipDetails))
      );
    }
  }

  getUserProfile() {
    // retrieve login info from local storage
    return JSON.parse(
      this.encriptionService.dec(localStorage.getItem("login_info"))
    ) as LoginResult;
  }
  setPortalAccessName(name) {
    localStorage.setItem(
      "okta_auth_application_Name",
      this.encriptionService.enc(JSON.stringify(name))
    );
  }
  getPortalAccessName() {
    return JSON.parse(
      this.encriptionService.dec(localStorage.getItem("okta_auth_application_Name"))
    );
  }

  removeBranchInfoFromLocalStorage() {
    localStorage.removeItem("branch_Info");
    localStorage.removeItem("user_preference");
  }

  isUserNotManager() {
    const profile = this.getUserProfile();
    const isManager = profile.SystemRole.toLowerCase().includes("manager");
    return isManager ? false : true;
  }
}